import React, { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { useDetail } from "seed/gql";
import { Loading } from "seed/helpers";
import View from "components/studio/forms/action_form/ActionForm.view";
import { usePost } from "seed/api";


function ActionForm({
  flowId,
  isValidator,
  toolboxRef,
  pageId,
  nodes,
  toolboxId,
  reloadFlow,
  createNode
}) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const defActionId = searchParams.get("def_action_id", null);
  const defAppId = searchParams.get("def_app_id", null);
  const rootParams = JSON.parse(searchParams.get("root_params", ""));
  const nodeParams = JSON.parse(searchParams.get("node_params", ""));
  const [isWizardMode, setIsWizardMode] = useState(false);
  const [activeActionId, setActiveActionId] = useState(defActionId);
  const [wizardFlow, setWizardFlow] = useState(null);
  const studioRef = useRef(null);

  const [isToolboxCollapsed, setIsToolboxCollapsed] = useState(false);
  const [toolboxActiveSection, setToolboxActiveSection] = useState("actions");

  const [callCreateWizardFlow] = usePost('/flows/create_wizard_flow', {
    onCompleted: (data) => setWizardFlow(data)
  });

  const reqFlow = useDetail(`{
    flow {
      name
      description
      token
      settings
      participants {
        role {
          name
        }
        user {}
      }
      user {
        email
        accountSettings
      }
    }
  }`, flowId, {
    notifyOnNetworkStatusChange: false
  });

  const onClickCloseToolbox = () => {
    setIsToolboxCollapsed(true);
  }

  const onClickOpenToolbox = () => {
    setIsToolboxCollapsed(false);
  }

  const onClickNode = (args) => {
    const { actionId } = args;
    setActiveActionId(actionId);
  }

  const onChangeMode = (wizardMode) => 
    setIsWizardMode(wizardMode);

  useEffect(() => {
    if(isWizardMode)
      callCreateWizardFlow({
        flow_id: flowId,
        parent_id: nodeParams?.parentId ?? null,
      });
  }, [isWizardMode]);

  if (reqFlow.loading) return <Loading />;
  if (reqFlow.error) return <div></div>;
  const { flow = {} } = reqFlow.data;

  return (
    <View
      toolboxRef={toolboxRef}
      studioRef={studioRef}
      flow={flow}
      pageId={pageId}
      nodes={nodes}
      toolboxId={toolboxId}
      defAppId={defAppId}
      activeActionId={activeActionId}
      rootParams={rootParams}
      nodeParams={nodeParams}
      activeSection={toolboxActiveSection}
      wizardFlow={wizardFlow}
      isValidator={isValidator}
      isCollapsed={isToolboxCollapsed}
      isWizardMode={isWizardMode}
      setActiveSection={setToolboxActiveSection}
      onClickNode={onClickNode}
      onClickOpenToolbox={onClickOpenToolbox}
      onClickCloseToolbox={onClickCloseToolbox}
      onChangeMode={onChangeMode}
      reloadFlow={reloadFlow}
      createNode={createNode}
    />
  );
}

export default ActionForm;